<template>
  <header class="topbar">
    <div class="left">
      <h2>Omnichannel</h2>
    </div>

    <div class="right">
      <button class="create-btn">＋ Create New Workflow</button>

      <div class="profile">
        <div class="badge">JD</div>
        <div class="info">
          <div class="name">John Doe</div>
          <div class="email">john.doe@fonetricks.com</div>
        </div>
      </div>

      <button class="logout-btn">↪</button>
    </div>
  </header>
</template>

<style scoped>
.topbar {
  height: 76px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.create-btn {
  border: none;
  background: #2f80ed;
  color: #fff;
  padding: 12px 18px;
  border-radius: 14px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
}

.profile {
  display: flex;
  align-items: center;
  gap: 10px;
}

.badge {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2f80ed;
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 700;
}

.info .name {
  font-size: 14px;
  font-weight: 600;
}

.info .email {
  font-size: 13px;
  color: #6b7280;
}

.logout-btn {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
}
</style>